var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

import { combineReducers } from 'redux';
import * as actions from '../actions';

function visibles() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments[1];

  switch (action.type) {
    case actions.ACTIVAR:
    case actions.MOSTRAR:
      return true;

    case actions.OCULTAR:
      return false;

    default:
      return state;
  }
}

function activas() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments[1];

  switch (action.type) {
    case actions.ACTIVAR:
      return true;

    case actions.DESACTIVAR:
      return false;

    default:
      return state;
  }
}

var nextPanelId = 0;

function paneles() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var action = arguments[1];
  var newState = void 0;

  switch (action.type) {
    case actions.CREAR_PANEL:
      newState = [].concat(state);
      newState.push({
        id: nextPanelId++,
        x: action.x,
        y: action.y,
        w: action.w,
        h: action.h
      });
      return newState;

    case actions.MOVER_PANEL:
      newState = state.map(function (panel) {
        if (panel.id === action.id) {
          return _extends({}, panel, {
            x: action.x,
            y: action.y,
            w: action.w,
            h: action.h
          });
        }

        return _extends({}, panel);
      });
      return newState;

    case actions.ELIMINAR_PANEL:
      newState = state.filter(function (panel) {
        return panel.id !== action.id;
      }).map(function (panel) {
        return _extends({}, panel);
      }); // newState = [...state];
      // delete newState[action.id];

      return newState;

    case actions.RESETEAR:
      return [];

    default:
      return state;
  }
}

var mascaras = combineReducers({
  activas: activas,
  visibles: visibles,
  paneles: paneles
});
export default mascaras;